import { color } from "style/constants";

export default {
  root: {
    fontSize: "1.125rem !important",
    height: 80,
    lineHeight: "1.75rem",
    textTransform: "none" as const,

    "&$selected": {
      color: color.BLACK,
      fontWeight: "bold"
    }
  },
  textColorInherit: {
    color: color.BLACK,
    opacity: 1
  }
};
